/** Contexto global de compañía emisora (análogo a nroSuc). */

import { clearGlobalNroSuc, readGlobalNroSuc } from './nroSucPreferida';

const STORAGE_KEY = 'idCompania';

export function readGlobalIdCompania(): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const id = String(raw ?? '').trim();
    return id || null;
  } catch {
    return null;
  }
}

export function persistGlobalIdCompania(idCompania: string): void {
  const id = String(idCompania ?? '').trim();
  if (!id) return;
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {}
}

export function clearGlobalIdCompania(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
}

/** Limpia preferencias globales de compañía/sucursal (login, logout, cambio de tenant). */
export function clearGlobalSucursalCompaniaPrefs(): void {
  clearGlobalIdCompania();
  clearGlobalNroSuc();
}

/**
 * Si el LS no corresponde a ninguna sucursal asignada del usuario, lo descarta.
 * No filtra listados: solo evita preferencias huérfanas.
 */
export function sanitizeGlobalSucursalCompaniaPrefs(
  sucursales: Array<{ nroSuc: number; idCompania?: string | null }>,
): void {
  const id = readGlobalIdCompania();
  if (id) {
    const tieneCompania = sucursales.some(
      (s) => String(s.idCompania ?? '').trim() === id,
    );
    if (!tieneCompania) clearGlobalIdCompania();
  }

  const nro = readGlobalNroSuc();
  if (nro != null) {
    const tieneSucursal = sucursales.some((s) => Number(s.nroSuc) === nro);
    if (!tieneSucursal) clearGlobalNroSuc();
  }
}
